export default "__VITE_ASSET__eb088d40__"